<template>
    <div class="row row-cols-1 row-cols-sm-auto g-4 justify-content-start">
        <div v-for="(item, index) in data" :key="index" class="col">
            <a :href="item.link || '/products/spirits/indian-indian-whiskey/1082'" class="coctails-item">{{ item.name }}</a>
        </div>
    </div>
</template>


<script>
export default {
    name: "CoctailsC",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    setup() {
        return {};
    },
}
</script>

<style lang="scss" scoped>
// btn default-link btn-sm w-100 btn-light text-dark text-uppercase fw-500 fs-14 fs-lg-18 zoom-hover rounded-pill
.coctails-item{
    display: block;
    width: 100%;
    background-color: #ffffff;
    color: #000000;
    text-transform: uppercase;
    border-radius: 30px;
    padding: 4px 22px;
}
.coctails-item:hover{
    background-color: #cfcccc;
}
</style>
